import { Link } from 'react-router-dom';
import { Button } from '@usacow/ds';
import { Showcase } from './Showcase';

const LOOP = [
  ['Read', 'Strip the story to entities, operations, and constraints.'],
  ['Model', 'Choose the formal object: array, interval, graph, tree, state, recurrence.'],
  ['Sniff constraints', 'Use N, Q, K, and limits to reject approaches that cannot pass.'],
  ['Eliminate', 'Say why the tempting wrong algorithm fails, before coding.'],
  ['Predict', 'Step the algorithm and predict the next state.'],
  ['Prove', 'State the invariant that makes it correct.'],
];

const METHOD = [
  [
    'Active, not passive',
    'You predict, classify, or construct before you ever see an explanation.',
  ],
  ['Why you were wrong', 'Every miss maps to a specific misconception and a targeted repair.'],
  ['Deterministic', 'Grading, hints, and traces are exact and instant — no chatbot, no guessing.'],
  [
    'Spaced repair',
    'Patterns you miss come back on a schedule until they transfer to new problems.',
  ],
];

export function MarketingHome() {
  return (
    <>
      <section className="mkt-hero">
        <div className="t-eyebrow">USACO reasoning trainer</div>
        <h1 className="mkt-hero__h">Learn to recognize the problem before solving it.</h1>
        <p className="mkt-hero__p">
          You know the topics. You still can&apos;t always tell what the problem wants. usaCow
          trains the invisible steps between reading a USACO problem and writing a correct solution
          — modeling, constraint reading, algorithm elimination, execution, and proof.
        </p>
        <div className="mkt-hero__cta">
          <Link to="/auth">
            <Button variant="primary" size="lg">
              Start the diagnostic
            </Button>
          </Link>
          <span className="mkt-hero__free">Free. No card.</span>
        </div>
      </section>

      <section className="mkt-section" id="loop">
        <h2 className="mkt-section__h">The loop strong competitors run before they code</h2>
        <div className="mkt-loop">
          {LOOP.map(([title, body], i) => (
            <div className="mkt-loop__step" key={title}>
              <span className="mkt-loop__n">{String(i + 1).padStart(2, '0')}</span>
              <div>
                <div className="mkt-loop__t">{title}</div>
                <div className="mkt-loop__b">{body}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Showcase />

      <section className="mkt-section" id="method">
        <h2 className="mkt-section__h">Why it works</h2>
        <div className="mkt-method">
          {METHOD.map(([title, body]) => (
            <div className="mkt-method__card" key={title}>
              <div className="mkt-method__t">{title}</div>
              <div className="mkt-method__b">{body}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="mkt-cta">
        <h2 className="mkt-cta__h">Find your bottleneck in 14 minutes.</h2>
        <p className="mkt-cta__p">
          The diagnostic measures how you read and model problems — not how many you&apos;ve solved.
        </p>
        <Link to="/auth">
          <Button variant="primary" size="lg">
            Start free
          </Button>
        </Link>
      </section>
    </>
  );
}
